import { render, staticRenderFns } from "./SlideManageView.vue?vue&type=template&id=dce0064e&scoped=true&"
import script from "./SlideManageView.vue?vue&type=script&lang=js&"
export * from "./SlideManageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce0064e",
  null
  
)

export default component.exports